<template>
  <div class="award-main">
    <div class="award-main__title">
      Penghargaan <span>kami</span>
    </div>

    <!-- tabs -->
    <div class="button-wrap">
      <div class="button-wrap__button-tab">
        <div
          v-for="i of 5"
          :key="i"
          class="button-tab-year"
          :class="active === `202${i}` ? 'active' : ''"
          @click="changeYear(i)"
        >
          {{ `202${i}` }}
        </div>
      </div>
    </div>

    <!-- carousel award -->
    <div class="award-main__slider">
      <div class="award-main__slider__wrap">
        <Carousel
          ref="carousel"
          slider-dot-position="center"
          :name="carouselName"
          :size="isDesktopWidth ? listChunk.length - 3 : listChunk.length - 1"
          :total-all-data="selectedDataAward.length - 3"
          :auto-play="true"
          :auto-play-interval="5000"
          color-slider="whiteWithRoundBlackM"
          :is-hide-button="selectedDataAward.length < 5 ? true : false"
          :shimmer="false"
          :class="
            `award-main__slider__carousel-main ${
              listChunk.length <= 3 ? 'center-content' : ''
            }`
          "
          :scroll-focus="false"
        >
          <template #item>
            <div
              v-for="(slide, index) in listChunk"
              :id="`${carouselName}-${index + 1}`"
              :key="`${index}-key`"
              :class="
                `${
                  listChunk.length === 1
                    ? 'award-main__slider__card-center-content'
                    : 'award-main__slider__card-wrap'
                }`
              "
            >
              <div
                v-for="(testi, j) in slide"
                :id="`id-${carouselName}-${index}-${j}`"
                :key="`key-${index}-${j}`"
                :class="
                  `class-${carouselName} award-main__slider__card-wrap__card`
                "
              >
                <!-- header -->
                <div class="award-main__slider__card-wrap__card__head">
                  <div class="award-main__slider__card-wrap__card__head__img">
                    <img
                      :src="
                        require(`@/assets/new-home/${
                          testi.src
                        }`)
                      "
                      :alt="testi.name + '.png'"
                    >
                  </div>
                </div>

                <!-- body -->
                <div class="award-main__slider__card-wrap__card__body">
                  <div class="award-main__slider__card-wrap__card__body__text">
                    {{ testi.title }}
                  </div>
                </div>

                <!-- footer -->
                <div class="award-main__slider__card-wrap__card__footer">
                  <div
                    class="award-main__slider__card-wrap__card__footer__text"
                  >
                    {{ testi.awardBy }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Carousel>
      </div>
    </div>

    <!-- blog tips -->
    <!-- <div class="award-main__blog">
      <Article />
    </div> -->
  </div>
</template>

<script>
import {
  chunkArray,
  MEDIA,
  generateChunkCarouselResponsive,
} from "@/components/new-carousel/util.js";
import Data from "../app/constants/index";
import Carousel from "@/components/new-carousel/Carousel";
import mixinMobile from "@/misc/mixinMobile";
// import Article from "../components/article.vue";

export default {
  name: "AwardSectionHome",
  components: {
    Carousel,
    // Article,
  },
  mixins: [mixinMobile],
  props: {
    data: {
      type: Array,
      default: () => [],
      require: true,
    },
  },
  data() {
    return {
      carouselName: "awardSectionCarousel-2025",
      isMobileWidth: false,
      bigScreen: false,
      Data,
      active: "2025",
      selectedDataAward: Data.AWARD_2025,
      isDesktopWidth: false,
    };
  },
  computed: {
    listChunk() {
      return chunkArray(this.selectedDataAward, 1);
    },
  },
  async created() {
    this.isMobile();
    this.isDesktop();
  },
  methods: {
    changeYear(idx) {
      this.active = `202${idx}`;
      this.selectedDataAward = this.Data[`AWARD_${this.active}`];
      this.carouselName = `awardSectionCarousel-202${idx}`;
      this.$refs.carousel.scrollToPosition(1);
    },
    isMobile() {
      this.isMobileWidth =
        generateChunkCarouselResponsive(window.innerWidth) === MEDIA().MOBILE;
    },
    isDesktop() {
      this.isDesktopWidth = window.innerWidth > 1180;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";
.award-main {
  margin: auto;
  background: url("@/assets/new-home/award/award-bg.webp") no-repeat left center;
  background-size: cover;
  padding: 50px 7%;

  @include for-size(mobile) {
    background: url("@/assets/new-home/award/award-bg.webp");
  }

  &__title {
    max-width: 1200px;
    margin: auto;
    color: $color-red-5;
    text-align: center;
    font-size: 48px;
    font-weight: 700;

    span {
      color: $color-indigo-dark;
    }

    @include for-size(mobile) {
      font-size: 24px;
    }
  }

  &__slider {
    ::v-deep .slides {
      position: relative;
      scroll-snap-type: unset;
      -webkit-scroll-snap-type: unset;
      overflow-x: hidden;
    }

    ::v-deep .wrapper-bottom {
      visibility: hidden;
    }

    &__wrap {
      display: flex;
      justify-content: center;
    }

    &__carousel-main {
      max-width: 1200px;
      width: 100%;
      max-height: 300px;

      @include for-size(mobile) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      @include for-size(mobile-landscape) {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    @include for-size(mobile) {
      ::v-deep .slides {
        overflow-x: auto !important;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
      }

      ::v-deep .wrapper-bottom {
        margin-top: 20px;
        visibility: visible !important;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }

    @include for-size(mobile-landscape) {
      ::v-deep .slides {
        overflow-x: auto !important;
        -webkit-mask-image: none !important;
        mask-image: none !important;
        scroll-snap-type: x mandatory;
        -webkit-scroll-snap-type: x mandatory;

        &::-webkit-scrollbar {
          height: 0;
          background: transparent; /* Optional: just make scrollbar invisible */
        }
      }

      ::v-deep .wrapper-bottom {
        margin-top: 20px;
        visibility: visible !important;
      }

      ::v-deep #slider-dots {
        & > span {
          width: 10px;
          height: 8px;
          background: $color-gray-pensive-5;
          border-radius: 6px;
          margin: 0 0.3rem 0 0;

          &:active {
            top: unset;
          }
        }

        .active-slider {
          width: 32px;
          background-color: $color-indigo-dark !important;
        }
      }
    }

    @include for-size(tablet-portrait) {
      display: unset;

      ::v-deep .slides {
        overflow-x: hidden;
      }

      ::v-deep .wrapper-bottom {
        visibility: hidden;
      }
    }

    &__card-center-content {
      display: flex;
      justify-content: center;
    }

    &__card-wrap {
      width: 25%;

      @include for-size(mobile) {
        width: 50%;
      }

      @include for-size(mobile-landscape) {
        width: 50%;
      }

      &__card {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        width: 100%;
        max-height: 300px;

        @include for-size(mobile) {
          width: 100%;
        }

        @include for-size(tablet-portrait) {
          width: 100%;
        }

        &__head {
          display: flex;
          margin-bottom: 10px;
          align-items: center;
          justify-content: center;
          width: 90%;

          &__img {
            width: 120px;
            height: 153px;
            display: flex;
            justify-content: center;
            align-items: center;

            @include for-size(tablet-portrait) {
              height: 100%;
              width: unset;
            }

            @include for-size(mobile-landscape) {
              height: 100%;
              width: unset;
            }
            
            @include for-size(mobile) {
              height: 100%;
              width: 100%;
            }
          }

          &__text {
            width: 210px;
            padding: 10px;
            text-align: left;

            &__name {
              color: $color-indigo-dark;
              font-size: 20px;
              line-height: 24px;
              font-weight: 700;
              margin-bottom: 5px;

              @include for-size(mobile) {
                font-size: 16px;
                line-height: 20px;
              }
            }

            &__title {
              color: $color-base-text;
              font-size: 16px;
              line-height: 20px;
              font-weight: 500;

              @include for-size(mobile) {
                font-size: 14px;
                line-height: 17px;
              }
            }
          }
        }

        &__body {
          display: flex;
          justify-content: center;
          height: max-content;
          min-height: 85px;

          @include for-size(mobile) {
            min-height: 40px;
          }

          @include for-size(tablet-portrait) {
            min-height: 60px;
          }

          &__text {
            text-align: center;
            font-size: 14px;
            line-height: 16px;
            font-weight: 700;
            width: 90%;
            color: $color-indigo-dark;

            @include for-size(tablet-portrait) {
              font-size: 8px;
              line-height: 10px;
            }

            @include for-size(mobile) {
              font-size: 8px;
              line-height: 10px;
            }
          }

          @include for-size(mobile) {
            height: 40px;
          }
        }

        &__footer {
          margin-top: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          width: 100%;

          &__text {
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
            color: $color-text-small;
            width: 90%;

            @include for-size(tablet-portrait) {
              font-size: 10px;
            }

            @include for-size(mobile) {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}

.button-wrap {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: auto;

  &__button-tab {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 40px auto;
    gap: 8px;
    background-color: $color-gray-pensive-8;
    max-width: 556px;
    height: 65px;
    border-radius: 80px;
    padding: 8px;

    @include for-size(mobile) {
      gap: 1px;
      max-width: 520px;
      height: 52px;
      padding: 4px 6px;
      margin: 20px 0 0;
    }

    .button-tab-year {
      height: 100%;
      width: 82px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 80px;
      color: $color-text-small;
      padding: 4px 24px;
      cursor: pointer;
      font-size: 20px;
      font-weight: 600;
      line-height: 21px;

      @include for-size(mobile) {
        width: 58px;
        height: 44px;
        font-size: 14px;
      }
    }

    .active,
    .button-tab-year:hover {
      color: $color-white;
      background-color: $color-indigo-dark;
      height: 48px;
      width: 82px;

      @include for-size(mobile) {
        width: 58px;
        height: 44px;
        font-size: 14px;
      }
    }
  }
}

.custom-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 24px;
  max-width: 183px;
  height: 44px;
}

::v-deep .slide-number {
  @include for-size(mobile) {
    margin: 0 7px;
    width: 100%;
  }
}

::v-deep .slide-item {
  margin: 0 12px;

  @include for-size(mobile) {
    margin: 0 7px;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:last-of-type {
    margin-right: 0;
  }
}

.center-content {
  ::v-deep #slides-wrapper {
    justify-content: center !important;

    @include for-size(mobile) {
      justify-content: unset !important;
    }

    @include for-size(mobile-landscape) {
      justify-content: unset !important;
    }
  }
}
</style>
